<template lang="pug">
  .select-technician
    div
      button.change-button(
        :disabled="disabled || loading"
        @click="devolverABodega()")
        b-spinner(v-if="loading" small)
        span {{ loading ? 'Procesando...' : 'Devolver a bodega' }}
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionDevolverBodega',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],

  data() {
    return {
      state: false,
      usuarios: [],
    }
  },
  methods: {
    ...mapActions('OTStore', ['editOT', 'devolverBodega']),
    async devolverABodega() {
      try {
        await this.executeWithLoading(async () => {
          const payload = {
            ot: this.ot.ot,
            user: this.user.user.id,
          }
          const resp = await this.devolverBodega(payload)
          if (resp.status === 200) {
            this.$bvToast.toast(
              `OT entregada a bodega
            a las ${moment(resp.data.fecha_hora).format('DD/MM/YYYY HH:mm')}`,
              {
                variant: 'success',
              }
            )
            this.$emit('changed')
          } else {
            this.$bvToast.toast(
              `Error al crear el movimiento de recepción: ${resp.data}`,
              {
                variant: 'danger',
              }
            )
          }
        })
      } catch (error) {
        console.error('Error al devolver a bodega:', error)
        this.$bvToast.toast('Error al devolver a bodega', {
          variant: 'danger',
        })
      }
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
}
</script>
